module.exports = __webpack_public_path__ + "media/newstyle/images/stars_sprint_orange-ec8cbfb2ffdecd50e402720507af6732.svg";